import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {filterUrl, isInternalLink} from "../../helpers/filters";
import './FloatingDownload.scss';
import {trackEventByUrl} from "../../helpers/events";

interface Data {
    paragraphById: {
        fieldColorText: string;
        fieldColorBackground: string;
        fieldRightOrLeftAlignment: string;
        fieldPinToSideRemoveMargin: boolean;
        fieldAddArrowNextToText: boolean;
        fieldVarLink: Array<{
            url: Array<{
                path: string;
                routed: boolean;
            }>;
            title: string;
        }>;
    }
}

class FloatingDownloadQuery extends Query<Data, {id: string}> {}

const GET_COMPONENT = gql`
query paragraphById($id: String!) {
  paragraphById: paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphComponentFloatingLinkCallout {
          fieldColorText
          fieldColorBackground
          fieldRightOrLeftAlignment
          fieldPinToSideRemoveMargin
          fieldAddArrowNextToText
          fieldVarLink {
              url {
                path
                routed
              }
              title
          }
        }
      }
    }
  }
}

`;


const FloatingDownload = ({id, markComponentLoadedAs}) => (
    <FloatingDownloadQuery asyncMode query={GET_COMPONENT} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error || !data.paragraphById) {
                markComponentLoadedAs(id, true);
                return <div>{error || null}</div>;
            }

            const field = data.paragraphById;
            let classNames = 'floatingDL';
            if (field.fieldRightOrLeftAlignment && field.fieldRightOrLeftAlignment === 'right') {
                classNames += ' floatingDL--right';
            }
            if (field.fieldPinToSideRemoveMargin) {
                classNames += ' floatingDL--no-margin';
            }
            if (field.fieldAddArrowNextToText) {
                classNames += ' floatingDL--text-cta-arrow';
            }

            const linkIsInternal = isInternalLink(field.fieldVarLink.url.path);

            markComponentLoadedAs(id, true);

            if (!window.floatingDLs.includes(id)) {
                window.floatingDLs = window.floatingDLs ?  [...window.floatingDLs, id] : [id];
            }

            const floatingDLs = [...window.floatingDLs];
            floatingDLs.reverse();

            // Add class for secondary floatingDLs
            if (window.floatingDLs.indexOf(id) > 0) {
                classNames += ' floatingDL--stacked';
            }

            // Determine the largest element width to set as minimum width
            let largestWidth = 0;
            const floatingDL = document.getElementsByClassName('floatingDL');
            if (floatingDL && floatingDL.length > 0) {
                Array.from(floatingDL).forEach(e => {
                    const dimensions = e.getBoundingClientRect();
                    if (dimensions.width > largestWidth) largestWidth = dimensions.width;
                });
            }

            return (
                <a href={filterUrl(field.fieldVarLink.url.path)}
                   className={classNames}
                   target={linkIsInternal ? '_self' : '_blank'}
                   rel={linkIsInternal ? null : 'noopener noreferrer'}
                   style={{
                    color: field.fieldColorText,
                    backgroundColor: field.fieldColorBackground,
                    transform: `translateY(-${40 * (floatingDLs ? floatingDLs.indexOf(id) : 0)}px)`,
                    minWidth: largestWidth
                   }}
                   onClick={() => trackEventByUrl(field.fieldVarLink.url.path, field.fieldVarLink.title)}
                >
                    {field.fieldVarLink.title}{field.fieldAddArrowNextToText ? (<span className="fal fa-long-arrow-right"/>) : null}
                </a>
            );
        }}
    </FloatingDownloadQuery>
);

FloatingDownload.propTypes = {
    id: PropTypes.number.isRequired,
    markComponentLoadedAs: PropTypes.func.isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    handleLoadedComponents: PropTypes.func.isRequired
};

export default FloatingDownload;



// WEBPACK FOOTER //
// ./frontend/components/FloatingDownload/FloatingDownload.jsx